import { DeliveryProviderService } from '../api/openapi_gen/deliveryProviderPortal/deliveryProvider';

import ProviderLifecycleStatus = DeliveryProviderService.ProviderLifecycleStatus;
import { useCommonAppServices } from '../services/ContextProviders';
import { useObservableAndState } from './useObservableAndState';

/**
 * Observable counterpart of `selectIsSelectedProviderInOnboarding` in
 * app/src/rdx/account/selectors.ts (DML-6028): the selected provider is still
 * onboarding regardless of signup source or how many providers the account has.
 */
export const useIsSelectedProviderInOnboarding = () => {
  const { accountService } = useCommonAppServices();
  const selectedProvider = useObservableAndState(accountService.getSelectedProviderData$());

  return selectedProvider?.lifecycle_status === ProviderLifecycleStatus.ONBOARDING;
};
